import { Injectable } from '@angular/core';
import { CaseEventTrigger } from '../../../domain';
import { Subject } from 'rxjs';

@Injectable()
export class EventTriggerService {

  eventTriggerSource = new Subject<CaseEventTrigger>();

  announceEventTrigger(eventTrigger: CaseEventTrigger) {
    this.eventTriggerSource.next(eventTrigger);
  }

}
